<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100 md-size-30">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>downhill_skiing</md-icon>
                    </div>
                    <h4 class="title">Skill Information Page</h4>
                </md-card-header>
                <div class="card-content">
                    <md-table class="m-4">
                        <row-item-view label="Name" :value="skill.name"/>
                        <row-item-view label="Display Name" :value="skill.display_name"/>
                        <row-item-view label="Code" :value="skill.code"/>
                        <row-item-view label="Category"
                                   :value="skill.skillCategory?skill.skillCategory.name
                                   :skill.skill_category_id"/>
                        <row-item-view label="Labourer Assigned"
                                   :value="skill.labourers?skill.labourers.length:'0'"/>
                        <row-item-view label="Activities Assigned"
                                   :value="skill.activities?skill.activities.length:'0'"/>
                        <row-item-view label="Labourer Used"
                                   :value="skill.labourerSchedules?skill.labourerSchedules.length:'0'"/>
                    </md-table>
                </div>
            </md-card>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-70">
            <md-card-content>
                <nav-tabs-card>
                    <template slot="content">
                        <md-tabs class="md-info md-white" md-alignment="left">
                            <md-tab id="tab-home" md-label="Activities" md-icon="lock">
                                <md-button class="md-primary md-raised"
                                           @click="addActivity">
                                    Assign Activity to {{skill.name}} Skill
                                </md-button>
                                <skill-activities-table :tableData="skill.activities"
                                                        :skill="skill"
                                                        @removeActivity="deleteActivityRow"
                                                        @editSkill="goToEdit"
                                                        @addActivityToSkill="addActivity"
                                ></skill-activities-table>
                            </md-tab>
                            <md-tab id="tab-labourers" md-label="Labourers List" md-icon="supervisor_account">
                                <md-button class="md-primary md-raised"
                                           @click="addLabourer">
                                    Assign Labourer to {{skill.name}} Skill
                                </md-button>
                                <skill-labourers-table :tableData="skill.labourers"
                                                       :skill="skill"
                                                       @removeLabourer="removeLabourerFromSkill"
                                                       @addLabourerToSkill="addLabourer"
                                ></skill-labourers-table>

                            </md-tab>
                        </md-tabs>
                    </template>
                </nav-tabs-card>
                <modal v-if="addLabourerModel" @close="addLabourerModalHide">
                    <template slot="header">
                        <h4 class="modal-title">Add Labourer to {{skill.name}} skill</h4>
                        <md-button
                                class="md-simple md-just-icon md-round modal-default-button"
                                @click="addLabourerModalHide">
                            <md-icon>clear</md-icon>
                        </md-button>
                    </template>
                    <template slot="body">
                        <multiselect v-model="new_labourer" id="index" label="name" track-by="labourer_number"
                                     placeholder="Type to search" open-direction="bottom"
                                     :options="labourers" :multiple="true" :searchable="true" :loading="isLoading"
                                     :internal-search="false" :clear-on-select="true" :close-on-select="true"
                                     :options-limit="300" :max-height="600"
                                     :show-no-results="true" :hide-selected="false"
                                     @search-change="labourerFind">
                            <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                        </multiselect>
                    </template>

                    <template slot="footer">
                        <md-button class="md-simple" @click="addLabourerSubmit">Add</md-button>
                        <md-button
                                class="md-danger md-simple"
                                @click="addLabourerModalHide">Close
                        </md-button>
                    </template>
                </modal>

                <modal v-if="addActivityModel" @close="hideActivityModal">
                    <template slot="header">
                        <h4 class="modal-title">Add Activity to {{skill.name}} Skill</h4>
                        <md-button
                                class="md-simple md-just-icon md-round modal-default-button"
                                @click="hideActivityModal">
                            <md-icon>clear</md-icon>
                        </md-button>
                    </template>

                    <template slot="body">
                        <multiselect
                                v-model="new_activity"
                                deselect-label="Can't remove this value"
                                track-by="name"
                                :multiple="true"
                                label="name"
                                placeholder="Select Activity to Add"
                                :options="activities"
                                :searchable="true"
                                :allow-empty="false">
                        </multiselect>
                    </template>

                    <template slot="footer">
                        <md-button class="md-simple" @click="addActivitySubmit">Add Selected Activity</md-button>
                        <md-button
                                class="md-danger md-simple"
                                @click="hideActivityModal">Close
                        </md-button>
                    </template>
                </modal>
            </md-card-content>
        </div>
    </div>
</template>

<script>
import { Modal, NavTabsCard } from '@/components';
import Multiselect from 'vue-multiselect';

// import ItemsView from "../../../components/Inputs/ItemsView";
// import ItemView from "../../../components/Inputs/ItemView";
import Swal from 'sweetalert2';
import SkillActivitiesTable from '../../../components/Tables/SkillActivitiesTable';
import SkillLabourersTable from '../../../components/Tables/SkillLabourersTable';
import RowItemView from '../../../components/Inputs/RowItemView';

export default {
    components: {
        RowItemView,
        SkillLabourersTable, SkillActivitiesTable, NavTabsCard, Modal, Multiselect },

    data: () => ({

        skill: {
            type: 'skills',
            name: null,
            display_name: null,
            code: null,
            skill_category_id: null,
            active: null,
            activities: [],
            labourers: [],
        },
        available_category_dropdown: [],
        isLoading: false,
        addLabourerModel: false,
        addActivityModel: false,
        new_labourer: [],
        new_activity: [],
        labourers: [],
        activities: []
    }),

    created () {
        this.get();
        this.getCategoryDropDowns();
    },

    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                let params = {
                    include: 'labourers,activities',
                    id: id
                };
                await this.$store.dispatch('skills/get', params);
                this.skill = this.$store.getters['skills/skill'];
            } catch (e) {
                await this.$store.dispatch('alerts/alert', e.response ? e.response : e.message);
            }
        },
        async labourerFind (query) {
            console.log(query.length);
            if (query.length > 2) {
                this.isLoading = true;
                let params = {
                    filter: {
                        queryKey: query
                    }
                };
                await this.$store.dispatch('labourers/list', params).then(() => {
                    this.labourers = this.$store.getters['labourers/list'];
                    this.isLoading = false;
                });
            }
        },

        async update () {
            try {
                await this.$store.dispatch('skills/update', this.skill);
                await this.$store.dispatch(
                    'alerts/success',
                    'Skills updated successfully.'
                );
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        getCategoryDropDowns () {
            this.$store.dispatch('skillCategories/list').then(() => {
                this.available_category_dropdown = this.$store.getters['skillCategories/dropdown'];
                if (this.available_category_dropdown && this.available_category_dropdown.length) {
                    console.log(this.available_category_dropdown);
                    this.skill.skill_category_id = this.available_category_dropdown[0].id;
                }
            });
        },
        goBack () {
            this.$router.push({ name: 'Skills List' });
        },
        goToEdit (id) {
            this.$router.push({ name: 'Edit Skill', params: { id } });
        },
        removeActivityFromSkill (item) {
            Swal.fire({
                title: 'Are you sure?',
                text: `Remove activity '${item.name}' from skill ${this.skill.name}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-success btn-fill',
                cancelButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteActivityRow(item);
                    Swal.fire({
                        title: 'Deleted!',
                        text: `You deleted activity '${item.name}'`,
                        icon: 'success',
                        confirmButtonClass: 'md-button md-success btn-fill',
                        buttonsStyling: false
                    });
                }
            });
        },
        removeLabourerFromSkill (item) {
            Swal.fire({
                title: 'Are you sure?',
                text: `Remove labourer '${item.name}' from skill ${this.skill.name}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-success btn-fill',
                cancelButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteLabourerRow(item);
                    Swal.fire({
                        title: 'Deleted!',
                        text: `You remove labourer '${item.name}'`,
                        icon: 'success',
                        confirmButtonClass: 'md-button md-success btn-fill',
                        buttonsStyling: false
                    });
                }
            });
        },
        deleteActivityRow (item) {
            let indexToDelete = this.skill.activities.findIndex(
                tableRow => tableRow.id === item.id
            );
            if (indexToDelete >= 0) {
                this.skill.activities.splice(indexToDelete, 1);
                this.update();
            }
        },
        deleteLabourerRow (item) {
            let indexToDelete = this.skill.labourers.findIndex(
                tableRow => tableRow.id === item.id
            );
            if (indexToDelete >= 0) {
                this.skill.labourers.splice(indexToDelete, 1);
                this.update();
                this.searchedLabourers = this.skill.labourers;
            }
        },
        async addLabourer () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('labourers/list', id);
                this.labourers = this.$store.getters['labourers/list'];
                this.addLabourerModel = true;
            } catch (e) {
                await this.$store.dispatch('alerts/alert', e.response ? e.response : e.message);
            }
        },
        async addActivity () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('activities/list', id);
                this.activities = this.$store.getters['activities/list'];
                this.addActivityModel = true;
            } catch (e) {
                await this.$store.dispatch('alerts/alert', e.response ? e.response : e.message);
            }
        },
        async addLabourerSubmit () {
            try {
                if (this.labourers.length > 0) {
                    let labourerIds = this.skill.labourers.map(p => p.id);
                    let updateNeeded = false;
                    this.new_labourer.forEach(labourer => {
                        if (!labourerIds.includes(labourer.id)) {
                            this.skill.labourers.push(labourer);
                            updateNeeded = true;
                        } else {
                            this.$store.dispatch(
                                'alerts/error',
                                `Oops, ${labourer.name} already on list!`
                            );
                        }
                    });
                    if (updateNeeded) {
                        await this.update();
                    }
                }
                this.addLabourerModalHide();
                this.new_labourer = [];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        async addActivitySubmit () {
            try {
                if (this.activities.length > 0) {
                    let activityIds = this.skill.activities.map(p => p.id);
                    let updateNeeded = false;
                    this.new_activity.forEach(activity => {
                        if (!activityIds.includes(activity.id)) {
                            this.skill.activities.push(activity);
                            updateNeeded = true;
                        } else {
                            this.$store.dispatch(
                                'alerts/error',
                                `Oops, ${activity.name} already on list!`
                            );
                        }
                    });
                    if (updateNeeded) {
                        await this.update();
                    }
                }
                this.hideActivityModal();
                this.new_activity = [];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/alert', e.response);
            }
        },
        addLabourerModalHide () {
            this.addLabourerModel = false;
        },
        hideActivityModal () {
            this.addActivityModel = false;
        }
    },
};
</script>
